import React from 'react';

import { StyledBlur, StyledContainer } from './Blurrable.styles';

/**
 * Blurrable is responsible for putting content inside a blurrable div that is being
 * shown when an overlay is rendered on top. It blurs everything underneath the overlay.
 */

export type BlurrableProps = {
  blur: boolean;
};

export const Blurrable: React.FC<BlurrableProps> = ({ children, blur }) => (
  <StyledContainer>
    <StyledBlur blur={blur}>{children}</StyledBlur>
  </StyledContainer>
);
